import { LabelsActions, fetchAllOrgLabelActionTypes,SET_ORGLABELS,SetOrgLabelsAction } from './fetchAllLabels'
import { Label } from "../../../../models"
import { FetchErrorInfo, SuccessFetchingAction, ErrorFetchingAction } from '../../../../utils/request-actions-helpers/createRequestActions'


export interface LabelsState {
    labels: Label[]
    isFetching: boolean
    error?: FetchErrorInfo
}

export const initialLabelsState: LabelsState = {
    isFetching: false,
    labels: []
}

export const labelsReducer = (state: LabelsState = initialLabelsState, action: LabelsActions): LabelsState => {
    switch (action.type) {
        case fetchAllOrgLabelActionTypes.start: {
            return {
                ...state,
                isFetching: true,
            }
        }
        case fetchAllOrgLabelActionTypes.success: {
            const successAction = action as SuccessFetchingAction<Label[]>
            return {
                ...state,
                isFetching: false,
                labels: successAction.result
            }
        }        
        case SET_ORGLABELS: {
            const successAction = action as SetOrgLabelsAction
            return {
                ...state,
                isFetching: false,
                labels: successAction.orgLabels
            }
        }
        case fetchAllOrgLabelActionTypes.error: {
            const errorAction = action as ErrorFetchingAction

            return {
                isFetching: false,
                labels: state.labels,
                error: errorAction.error
            }
        }
        
        default:
            return state
    }
}